import { render, staticRenderFns } from "./GastroArticle.vue?vue&type=template&id=22cc00d2&scoped=true&"
import script from "./GastroArticle.vue?vue&type=script&lang=js&"
export * from "./GastroArticle.vue?vue&type=script&lang=js&"
import style0 from "./GastroArticle.vue?vue&type=style&index=0&id=22cc00d2&prod&scoped=true&lang=css&"
import style1 from "./GastroArticle.vue?vue&type=style&index=1&id=22cc00d2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22cc00d2",
  null
  
)

export default component.exports